import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import FinalSection from "@/components/FinalSection.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";

const routes = [
  {
    path: "/acreditarme",
    component: FormSection,
  },
  {
    path: "/:hash",
    component: FormSection,
  },
  {
    path: "/final",
    component: FinalSection,
  },
  {
    path: "/certificados",
    component: CertificadoSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import CertificadoSection from "@/components/CertificadoSection.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;